<div class="camera-card">
  <div class="camera-preview">
    <video #preview autoplay playsinline muted></video>
    <div class="preview-status" *ngIf="isLoading">Opening camera...</div>
    <div class="preview-status error" *ngIf="!isLoading && errorMessage">{{ errorMessage }}</div>
  </div>

  <div class="camera-details">
    <h2>{{ label }}</h2>

    <div class="control" *ngIf="capabilities?.supportsZoom">
      <div class="control-header">
        <label [for]="'zoom-' + deviceId">Zoom</label>
        <span>{{ formatValue(zoom) }}</span>
      </div>
      <input
        [id]="'zoom-' + deviceId"
        type="range"
        [min]="capabilities!.zoom!.min"
        [max]="capabilities!.zoom!.max"
        [step]="capabilities!.zoom!.step"
        [(ngModel)]="zoom"
        (ngModelChange)="onZoomChange()" />
    </div>

    <div class="control" *ngIf="capabilities?.supportsAutoFocus || capabilities?.supportsManualFocus">
      <div class="control-header">
        <label [for]="'focus-mode-' + deviceId">Focus</label>
      </div>
      <select
        [id]="'focus-mode-' + deviceId"
        [(ngModel)]="focusMode"
        (ngModelChange)="onFocusModeChange()">
        <option *ngIf="capabilities?.supportsAutoFocus" [value]="capabilities!.autoFocusMode">Auto</option>
        <option *ngIf="capabilities?.supportsManualFocus" value="manual">Manual</option>
      </select>
    </div>

    <div class="control" *ngIf="showFocusDistance">
      <div class="control-header">
        <label [for]="'focus-' + deviceId">Focus distance</label>
        <span>{{ formatValue(focusDistance) }}</span>
      </div>
      <input
        [id]="'focus-' + deviceId"
        type="range"
        [min]="capabilities!.focusDistance!.min"
        [max]="capabilities!.focusDistance!.max"
        [step]="capabilities!.focusDistance!.step"
        [(ngModel)]="focusDistance"
        (ngModelChange)="onFocusDistanceChange()" />
    </div>

    <p class="helper" *ngIf="!isLoading && !errorMessage && !hasAnyControls">
      This camera does not expose zoom or focus controls to the browser.
    </p>
  </div>
</div>
